import React from 'react';
import { Space, Tag, Divider, Typography } from 'antd';
import { SelectedFilters } from './selected-filters';
import { Permission2 } from '../models/permission2';

const { Text } = Typography;

export const Permission2Viewer = (props: { permissions: Permission2[] }) => {
  const { permissions } = props;

  if (!permissions || permissions.length === 0) {
    return null;
  }

  return (
    <Space direction="vertical" split={<Divider style={{ margin: '8px 0' }} />}>
      {permissions.map((permission, index) => (
        <Space key={index} size="large" split={<Divider type="vertical" />}>
          <Tag color={permission.effect === 'ALLOW' ? 'green' : 'red'} style={{ margin: 0 }}>
            {permission.effect === 'ALLOW' ? 'İzin ver' : 'Reddet'}
          </Tag>
          <Space direction="vertical">
            <Text>
              {permission.targetDetails?.targetGroupLabel} {permission.targetDetails?.targetActionLabel?.toLowerCase()}
            </Text>
            {permission.targetDetails?.dynamicValues && permission.targetDetails.dynamicValues.length > 0 && (
              <Space split="/" size="small">
                {permission.targetDetails.dynamicValues.map((v: any) => (
                  <Tag key={v.key} style={{ margin: 0 }}>
                    {v.valueLabel}
                  </Tag>
                ))}
              </Space>
            )}
          </Space>
          {permission.filterGroupDetails && (
            <Space>
              <span>Filtre:</span>
              <SelectedFilters filterGroup={permission.filterGroupDetails} />
            </Space>
          )}
        </Space>
      ))}
    </Space>
  );
};
